import '../Sass/App.scss';
import React, { useRef, useContext } from 'react';
import { useDrag, useDrop } from 'react-dnd'
import { MWContext } from '../Contexts/MWContext';

export function Card(props) {

    const virus_types = ['viral_listener','viral_function']
    const ml_types = ['normal','ifthen']
    const cardHeight = (virus_types.includes(props.cardData.card_type)) ? props.cardWidth * 0.7 : props.cardWidth * 1.4
    const { IMAGE_ROOT } = useContext(MWContext)

    var draggableType = 'dev-card'
    if (virus_types.includes(props.cardData.card_type)) {
        draggableType = 'viral-card'
    }
    if (ml_types.includes(props.cardData.card_type)) {
        draggableType = 'ml-card'
    }

    const [{ isDragging }, dragRef] = useDrag({
        type: draggableType,
        item: props,
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    })

    const [{ isOver }, dropRef] = useDrop({
        accept: ['dev-card','ml-card','viral-card'],
        drop: (item) => {
            const dragIndex = item.indexInSeries
            const dropIndex = props.indexInSeries
            if (props.currentHome == item.currentHome && dragIndex != (dropIndex)) {
                item.reorderHandler(dragIndex, dropIndex)
            } else if (props.currentHome != item.currentHome) {
                item.sendHandler(dragIndex, 1)
                props.receiveHandler(item.cardData, dropIndex)
            }
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })

    const ref = useRef(null)
    const dragDropRef = dragRef(dropRef(ref))

    function assetUrl(path) {
        if (!path) {
            return '';
        }

        if (/^(https?:\/\/|data:image\/)/i.test(path)) {
            return path;
        }

        if (path.startsWith('/game_assets/')) {
            return IMAGE_ROOT.replace(/\/game_assets\/?$/, '') + path;
        }

        return IMAGE_ROOT + '/' + path.replace(/^\/+/, '');
    }

    function getBackImage() {
        return assetUrl(props.cardData.back_image || props.cardData.default_back_image || props.codebase?.default_back_image);
    }

    function getCardStyle(isOver) {
        switch (props.cardStyle) {
            case 'hand':
                return {width: props.cardWidth, height: cardHeight, marginRight: (props.cardWidth / 1.5) * -1, borderColor: 'white' };
            case 'programGroup':
//                return {width: props.cardWidth, height: cardHeight, marginBottom: (cardHeight / 1.5) * -1, borderColor: 'white'};
                return {width: props.cardWidth, height: cardHeight, marginRight: (props.cardWidth / 1.5) * -1, borderColor: 'white', transform: 'rotate(' + props.cardData.rotation + 'deg)' };
            case 'deck':
                return {
                    width: props.cardWidth, 
                    height: cardHeight, 
                    backgroundImage: getBackImage() ? "url(" + getBackImage() + ")" : 'none',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }
            case 'virusCard':
                const offset = cardHeight / 1.75
                const addMargin = props.finalCard ? cardHeight - offset : 0
                return {width: props.cardWidth, height: cardHeight, margin: '2%', marginBottom: ((cardHeight / 1.75) * -1) + addMargin, borderRadius: 0.025 * props.cardWidth };
            default: 
                return {width: props.cardWidth, height: cardHeight, borderRadius: 0.025 * props.cardWidth};
        }
    }

    function getTypeStyle() {
        switch (props.cardData.card_type) {
            case 'function':
                return {backgroundColor: '#00B000', fontSize: props.cardWidth / 20};
            case 'listener':
                return {backgroundColor: '#A9A9FF', fontSize: props.cardWidth / 20};
            case 'procedure':
                return {backgroundColor: '#FFFFFF', fontSize: props.cardWidth / 20};
            case 'program':
                return {backgroundColor: '#000000', border: '1px solid #FFFFFF', leftPadding: '19%', color: '#FFFFFF', fontSize: props.cardWidth / 20};
            case 'viral_listener':
                return {backgroundColor: '#FF0000', fontSize: props.cardWidth / 20};
            case 'viral_function':
                return {backgroundColor: '#00B000', fontSize: props.cardWidth / 20};
            default:
                return {backgroundColor: '#FF409F', fontSize: props.cardWidth / 20};
        }
    }

    function getTextStyle() {
        switch (props.cardData.card_type) {
            case 'program':
                return {fontSize: props.cardWidth / 22, paddingLeft: '19%'};
            case 'viral_listener':
                return {fontSize: props.cardWidth / 17, paddingLeft: '5%'};
            case 'viral_function':
                return {fontSize: props.cardWidth / 17, paddingLeft: '5%'};
            case 'normal':
                return {fontSize: props.cardWidth / 16, paddingLeft: '5%', paddingRight: '5%'};
            case 'ifthen':
                return {fontSize: props.cardWidth / 16, paddingLeft: '28%', paddingRight: '5%'};
            default:
                return {fontSize: props.cardWidth / 22, paddingLeft: '14%'};
        }
    }

    function getBarStyle() {
        switch (props.cardData.card_type) {
            case 'viral_function':
                return {fontSize: props.cardWidth / 14, backgroundColor: '#00B000', height: '12%', paddingTop: '6%'};
            case 'viral_listener':
                return {fontSize: props.cardWidth / 14, backgroundColor: '#FF0000', height: '12%', paddingTop: '6%'};
            case 'normal':
            case 'ifthen':
                switch (props.cardData.x_level) {
                    case '1':
                        return {fontSize: props.cardWidth / 12, backgroundColor: '#FFFF00', color: 'black', height: '8%', paddingTop: '7%'};
                    case '2':
                        return {fontSize: props.cardWidth / 12, backgroundColor: '#FFA500', color: 'black', height: '8%', paddingTop: '7%'};
                    case '3':
                        return {fontSize: props.cardWidth / 12, backgroundColor: '#FF0000', color: 'white', height: '8%', paddingTop: '7%'};
                    default:
                        return {fontSize: props.cardWidth / 12, backgroundColor: '#FFFF00', color: 'black', height: '8%', paddingTop: '7%'};
                }
            default:
                switch (props.cardData.special) {
                    case 'necro':
                        return {fontSize: props.cardWidth / 15, background: 'linear-gradient(90deg, #333333 60%, #FF0000 100%)'};
                    case 'oos':
                        return {fontSize: props.cardWidth / 15, background: 'linear-gradient(90deg, #333333 60%, #A9A9FF 100%)'};
                    default:
                        return {fontSize: props.cardWidth / 15};
                }
        }
    }

    function getOutlineStyle() {
        switch (props.cardStyle) {
            case 'discard':
                return {visibility: 'visible', left: '0%', width: '100%'};
            case 'programGroup':
//                return {visibility: 'visible', left: '0%', top: '30%', width: '100%'};
                return {visibility: 'visible'};
            case 'virusCard':
                return {visibility: 'visible', left: '0%', top: '30%', width: '100%'};
            default:
                return {visibility: 'visible'};
        }
    }

    function getSpecialImage() {
        switch (props.cardData.special) {
            case 'necro':
                return IMAGE_ROOT + '/' + props.cardData.special_image;
            default:
                return IMAGE_ROOT + '/' + props.cardData.special_image;
        }
    }

    return (
        <>
        { props.cardStyle == 'deck' &&
            <div className="card-scalable" ref={dragDropRef} style={getCardStyle(isOver)} >
                { virus_types.includes(props.cardData.card_type) &&
                    <>
                    <div className="white-code" style={{ position: 'relative', left: '5%', top: '66%', margin: 0, fontSize: '0.8em', fontWeight: 'bold' }}>viral</div>
                    <div className="white-code" style={{ position: 'relative', left: '0%', top: '64%', width: '40%', margin: 0, padding: '1% 1% 1% 5%', fontSize: '0.8em', backgroundColor: props.cardData.card_type == 'viral_function' ? 'green' : 'red', color: 'black', fontWeight: 'bold' }}>{props.cardData.card_type == 'viral_function' ? 'functions' : 'listeners' }</div>
                    </>
                }
                { ml_types.includes(props.cardData.card_type) &&
                    <>
                    <div className="white-code" style={{ position: 'relative', left: '0%', top: '80%', width: '20%', margin: 0, padding: '0% 1% 1% 5%', fontSize: '1em', backgroundColor: props.cardData.x_level == 1 ? 'yellow' : props.cardData.x_level == 2 ? 'darkorange' : 'red', color: 'black', fontWeight: 'bold' }}>x={props.cardData.x_level}</div>
                    <div className="white-code" style={{ position: 'relative', left: '0%', top: '80%', width: '65%', margin: 0, padding: '1% 1% 1% 5%', fontSize: '0.7em', backgroundColor: 'black', color: 'white' }}>machine_learning</div>
                    </>
                }
            </div>
        }
        { (props.cardStyle != 'deck' && !virus_types.includes(props.cardData.card_type) && !ml_types.includes(props.cardData.card_type)) &&
            <div className="card-scalable" ref={props.notDraggable ? null : dragDropRef} style={getCardStyle(isOver)} onClick={()=>props.clickHandler(props.cardData, props.indexInSeries)} >
                <div className="card-outline" style={isOver ? getOutlineStyle() : {visibility: 'hidden'}} />
                <div className="card-type" style={getTypeStyle()}>{props.cardData.card_type}</div>
                { props.cardData.card_type != 'program' &&    
                    <img className="card-image" src={IMAGE_ROOT + '/' + props.cardData.image} />
                }
                { props.cardData.card_type == 'program' &&    
                    <img className="card-image" style={{marginTop: '-20%'}} src={IMAGE_ROOT + '/' + props.cardData.image} />
                }
                <div className="card-title" style={getBarStyle()}>
                    { props.cardData.flippable == 1 ?
                        props.flipped ? <span>{props.cardData.name_2}</span> : <span>{props.cardData.name_1}</span>
                    : <span>{props.cardData.name_1}<b>{props.cardData.name_2}</b></span> }
                    { props.cardData.include_parentheses == 1 ? <><span>(</span><span className="argument">{props.cardData.argument}</span><span>)</span></> : null }
                    { props.cardData.suffix }
                    { props.cardData.special &&  
                        <div style={{float: 'right', width: '10%', marginRight: '5%'}}>
                            <img className="card-special" src={getSpecialImage()} />
                        </div>
                    }
                </div>
                { props.cardData.card_type != 'program' &&    
                    <div className="card-lines" style={{fontSize: props.cardWidth / 25, lineHeight: 1.47}}>
                        1<br/>2<br/>3<br/>4<br/>5<br/>6<br/>7<br/>8<br/>9<br/>10<br/>11<br/>12<br/>13<br/>14<br/>15
                    </div>
                }
                { props.cardData.card_type == 'program' &&    
                    <div className="card-init" style={{fontSize: props.cardWidth / 22}}>init:</div>
                }
                <div className="card-text" style={getTextStyle()}>
                    { props.cardData.flippable == 1 ?
                        props.flipped ? <div className="card-text-block">{props.cardData.description_2}</div> : <div className="card-text-block">{props.cardData.description_1}</div>
                    : null }
                    { props.cardData.header_1 && props.cardData.flippable != 1 ? <div className="card-text-header">{props.cardData.header_1}</div> : null }
                    { props.cardData.description_1 && props.cardData.flippable != 1 ? <div className="card-text-block">{props.cardData.description_1}</div> : null }
                    { props.cardData.header_2 && props.cardData.flippable != 1 ? <div className="card-text-header">{props.cardData.header_2}</div> : null }
                    { props.cardData.description_2 && props.cardData.flippable != 1 ? <div className="card-text-block">{props.cardData.description_2}</div> : null }
                </div>
                { props.flipHandler &&
                    <button className="close-button" style={{right: props.cardWidth / 30, bottom: props.cardWidth / 30, height: props.cardWidth / 7, width: props.cardWidth / 3, fontSize: props.cardWidth / 12}} onClick={(e) => props.flipHandler(e)}>FLIP</button>
                }
                { props.showQuantity &&
                    <div className="card-quantity" style={{fontSize: props.cardWidth / 10}}>
                        <span>{props.cardData.quantity}x</span>
                    </div>
                }
            </div>
        }
        { (props.cardStyle != 'deck' && virus_types.includes(props.cardData.card_type)) &&
            <div className="card-scalable" ref={props.fixed ? dropRef : dragDropRef} style={getCardStyle(isOver)} onClick={()=>props.clickHandler(props.cardData)} >
                <div className="card-outline" style={isOver ? getOutlineStyle() : {visibility: 'hidden'}} />
                <div className="card-title" style={getBarStyle()}>
                    <span><b>{props.cardData.name_1}</b></span>
                    <span><b>{props.cardData.name_2}</b></span>
                    { props.cardData.include_parentheses == 1 ? <span><b>({props.cardData.argument})</b></span> : null }
                    { props.cardData.suffix }
                </div>
                <div className="card-text" style={getTextStyle()}>
                    { props.cardData.description && <div className="card-text-block">{props.cardData.description}</div> }
                </div>
                { props.showQuantity &&
                    <div className="card-quantity" style={{fontSize: props.cardWidth / 10}}>
                        <span>{props.cardData.quantity}x</span>
                    </div>
                }
            </div>
        }
        { (props.cardStyle != 'deck' && ml_types.includes(props.cardData.card_type)) &&
            <div className="card-scalable" ref={dragDropRef} style={getCardStyle(isOver)} onClick={()=>props.clickHandler(props.cardData)} >
                <div className="card-outline" style={isOver ? getOutlineStyle() : {visibility: 'hidden'}} />
                <div className="card-title" style={getBarStyle()}>
                        <span><b>{props.cardData.name_1}</b></span>
                        <span><b>{props.cardData.name_2}</b></span>
                        { props.cardData.include_parentheses == 1 ? <span><b>({props.cardData.argument})</b></span> : null }
                        { props.cardData.suffix }
                        { props.cardData.special &&  
                            <div style={{float: 'right', width: '10%', marginRight: '5%'}}>
                                <img className="card-special" src={getSpecialImage()} />
                            </div>
                        }
                </div>
                { props.cardData.card_type == 'ifthen' && <div className="card-init" style={{fontSize: props.cardWidth / 16, textAlign: 'right', marginLeft: '5%'}}>if:</div> }
                <div className="card-text" style={getTextStyle()}>                    
                    { props.cardData.description && <div className="card-text-block">{props.cardData.description}</div> }
                </div>
                { props.cardData.card_type == 'ifthen' && <div className="card-init" style={{fontSize: props.cardWidth / 16, textAlign: 'right', marginLeft: '5%'}}>then:</div> }
                <div className="card-text" style={getTextStyle()}>
                    { props.cardData.card_type == 'ifthen' && <div className="card-text-block">{props.cardData.then_text}</div> }
                </div>
                { props.cardData.card_type == 'ifthen' && <div className="card-init" style={{fontSize: props.cardWidth / 16, textAlign: 'right', marginLeft: '5%'}}>else:</div> }
                <div className="card-text" style={getTextStyle()}>
                    { props.cardData.card_type == 'ifthen' && <div className="card-text-block">{props.cardData.else_text}</div> }
                </div>
                { props.showQuantity &&
                    <div className="card-quantity" style={{fontSize: props.cardWidth / 10}}>
                        <span>{props.cardData.quantity}x</span>
                    </div>
                }
            </div>
        }
        { props.options && 
            <div>
                <button className="cli-button" onClick={() => props.sendHandler(props.indexInSeries)}>remove from play</button>
                <button className="cli-button" onClick={() => props.rotateHandler(props.indexInSeries)}>rotate 90 degrees</button>
                <button className="cli-button" onClick={() => props.modifyHandler(props.indexInSeries)}>modify</button>
            </div>
        }
        </>
    )
}
